import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'

import { PurchaseService } from '../../../services/purchase.service'
import { SsrService } from '../../../services/ssr.service'
import { PurchasedTrackType } from '../../../types/purchased-track.type'

@Component({
  selector: 'bmcore-purchased-tracks-page',
  templateUrl: './bmcore-purchased-tracks-page.component.html',
  styleUrls: ['./bmcore-purchased-tracks-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcorePurchasedTracksPageComponent implements OnInit {
  tracks: PurchasedTrackType[] = []
  showNotPurchasedTracksMessage = false
  isLoader = false

  constructor(
    private purchaseService: PurchaseService,
    private ssrService: SsrService
  ) {}

  ngOnInit(): void {
    this.getPurchasedBeats()
  }

  getPurchasedBeats() {
    this.isLoader = true
    this.ssrService.wait('bmcore-purchased-tracks-page')
    this.purchaseService.getPurchasedBeats().subscribe(resp => {
      this.ssrService.ready('bmcore-purchased-tracks-page')
      this.isLoader = false
      this.tracks = resp.items
      this.showNotPurchasedTracksMessage = !resp.items.length
    })
  }
}
